export enum WebhookEventTypes {
  LEAD_CREATED = "lead.created",
  LEAD_UPDATED = "lead.updated",
  LEAD_QUESTIONNAIRE_RESPONSE_ADDED = "lead.questionnaireResponseAdded",
  LEAD_NOTE_ADDED = "lead.noteAdded",
  LEAD_SYNCED = "lead.synced",
  LEAD_AVAILABILITY_ADDED = "lead.availabilityAdded",
}
